import React from "react";
import errorImage from "../../assets/error-image.svg";
export default function ErrorComponent() {
  return (
    <div className="error-image">
      <img src={errorImage} alt="Error" />
    </div>
  );
}
